import React from "react";

import { Grid } from "@material-ui/core";
import { useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";

import { deleteSaleLot } from "actions";

import { SubtleBadge } from "components/Badge";
import { ConfirmDialog, createModalTitle } from "components/ConfirmDialog";
import { FormCollapse } from "components/Form";
import { Input } from "components/Form/FormikControls";
import { MultiSkinsForm } from "components/MultiSkinsLotsForm";

import { formatDecimal } from "lib";

import { getSkinsSexId } from "selectors/sexes";
import { summarizeLots } from "./lib";

import { FormValues } from "./types";

const SkinsSummary = () => {
  const { values } = useFormikContext<FormValues>();

  const { saleLots, skinsLots } = values;
  const sexIdsToExludeFromQuantity = [useSelector(getSkinsSexId)];
  const summary = summarizeLots(
    [...saleLots, ...skinsLots],
    sexIdsToExludeFromQuantity,
  );
  const { averageDollarsPerKilo, dollarsPerHead, totalPriceDollars } = summary;

  const skinsSummary = summarizeLots(skinsLots);

  return (
    <>
      {skinsLots.length > 1 && (
        <>
          <Grid item xs={6} md={4}>
            <Input
              disabled
              name="totalSkins"
              align="right"
              label="Total Skins"
              overrideValue={skinsSummary.totalQuantity}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <Input
              disabled
              name="averageSkinsPrice"
              align="right"
              beforeSymbol="$"
              label="Avg Skin Price"
              overrideValue={formatDecimal(skinsSummary.dollarsPerHead)}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <Input
              disabled
              name="totalSkinsValue"
              align="right"
              beforeSymbol="$"
              label="Total Skin Value"
              overrideValue={formatDecimal(skinsSummary.totalPriceDollars)}
            />
          </Grid>
        </>
      )}

      <Grid item xs={6} md={4}>
        <Input
          disabled
          name="averagePricePerKgSkins"
          align="right"
          beforeSymbol="$"
          label="Avg $/kg (inc skins)"
          overrideValue={averageDollarsPerKilo}
        />
      </Grid>

      <Grid item xs={6} md={4}>
        <Input
          disabled
          name="dollarsPerHeadSkins"
          align="right"
          beforeSymbol="$"
          label="$/Hd (inc skins)"
          overrideValue={formatDecimal(dollarsPerHead)}
        />
      </Grid>

      <Grid item xs={6} md={4}>
        <Input
          disabled
          name="totalPriceSkins"
          beforeSymbol="$"
          align="right"
          label="Total (inc skins)"
          overrideValue={formatDecimal(totalPriceDollars)}
        />
      </Grid>
    </>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Default skins lot template props
export const SkinsForm = ({ defaultSkinsLot }: any) => {
  const formikProps = useFormikContext<FormValues>();
  const { values } = formikProps;

  const [confirmDeleteSaleLot, setConfirmDeleteSaleLot] = React.useState(null);

  const removeSaleLotAtIndex = index => {
    const nextValue = values.skinsLots.filter((_s, i) => i !== index);
    // If there is nothing left, add the default.
    const nextOrDefault =
      nextValue.length === 0 ? [defaultSkinsLot] : nextValue;

    formikProps.setFieldValue("skinsLots", nextOrDefault);
  };

  const closeConfirmDialog = () => setConfirmDeleteSaleLot(null);

  const handleClickDelete = (saleLot, index) => {
    if (!saleLot.id) {
      removeSaleLotAtIndex(index);
    } else {
      setConfirmDeleteSaleLot({ saleLot, index });
    }
  };
  const dispatch = useDispatch();
  const handleDelete = () => {
    const { saleLot, index } = confirmDeleteSaleLot;
    dispatch(deleteSaleLot(saleLot));
    removeSaleLotAtIndex(index);
    closeConfirmDialog();
  };

  return (
    <FormCollapse header={<SubtleBadge>Skins</SubtleBadge>}>
      <MultiSkinsForm handleClickDelete={handleClickDelete} />
      <SkinsSummary />
      <ConfirmDialog
        title={createModalTitle("this item")}
        isOpen={confirmDeleteSaleLot}
        onCancel={closeConfirmDialog}
        onDelete={handleDelete}
      />
    </FormCollapse>
  );
};
